import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=3c1d736a&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1d736a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c1d736a')) {
      api.createRecord('3c1d736a', component.options)
    } else {
      api.reload('3c1d736a', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=3c1d736a&scoped=true&", function () {
      api.rerender('3c1d736a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2W6Tle6s5Zzth/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports